import {
    WF_ACTIVITY_REGISTRY,
    WfActivityRegistryEntry
} from '../wf/interface/wf-activity-registry';
import {
    NsNotificationCommentWfProcessStepMainActivityComponent
} from './component/protected-components/wf/ns-notification-comment-wf-process-step-main-activity/ns-notification-comment-wf-process-step-main-activity.component';
import {
    NsNotificationCommentWfProcessStepSideActivityComponent
} from './component/protected-components/wf/ns-notification-comment-wf-process-step-side-activity/ns-notification-comment-wf-process-step-side-activity.component';

export const NS_WF_ACTIVITY_PROVIDER = [{
    provide: WF_ACTIVITY_REGISTRY,
    useValue: [
        ['notification', {
            mainComponent: NsNotificationCommentWfProcessStepMainActivityComponent,
            sideComponent: NsNotificationCommentWfProcessStepSideActivityComponent
        }],
    ] as WfActivityRegistryEntry[],
    multi: true
}];
